import { render, staticRenderFns } from "./ThirdAppMessageTest.vue?vue&type=template&id=9a449298&scoped=true&"
import script from "./ThirdAppMessageTest.vue?vue&type=script&lang=js&"
export * from "./ThirdAppMessageTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a449298",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9a449298')) {
      api.createRecord('9a449298', component.options)
    } else {
      api.reload('9a449298', component.options)
    }
    module.hot.accept("./ThirdAppMessageTest.vue?vue&type=template&id=9a449298&scoped=true&", function () {
      api.rerender('9a449298', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/jeecg/ThirdAppMessageTest.vue"
export default component.exports